import { SharedPrizeCarousel } from 'components/prize-carousel/SharedPrizeCarousel';
import { BOOST_PAGE_PRIZES } from 'constants/Prizes';
import { PrizeCarouselItem } from 'types/PrizeCarousel';

export const PrizeCarousel = ({
  prizes = BOOST_PAGE_PRIZES,
  mobileCardWidth = '90%',
  desktopCardWidth = '30%',
  textPosition = 'default',
  titleClassName,
  subheadingClassName,
}: {
  prizes?: PrizeCarouselItem[];
  mobileCardWidth?: string;
  desktopCardWidth?: string;
  textPosition?: 'default' | 'overlayBottom';
  titleClassName?: string;
  subheadingClassName?: string;
}) => {
  return (
    <SharedPrizeCarousel
      items={prizes}
      mobileCardWidth={mobileCardWidth}
      desktopCardWidth={desktopCardWidth}
      desktopInlinePadding="var(--dm2025-sitePadding)"
      slidePadding="4px"
      textPosition={textPosition}
      overlayVariant="solid"
      titleClassName={titleClassName}
      subheadingClassName={subheadingClassName}
      showButtonsOnMobile={false}
    />
  );
};
